import * as THREE from "three";
import { RoundedBoxGeometry } from "three/examples/jsm/geometries/RoundedBoxGeometry.js";
import GlobalColorSingleton from "./GlobalColor";
import * as TWEEN from "@tweenjs/tween.js";
import AudioEffects from "./AudioEffects";
export default class TitleLetter extends THREE.Group {
  constructor(size, textures) {
    super();
    this.textures = textures;
    this.name = "title_letter";
    this.roll_is_authorized = true;

    const DEFAULT_COLOR = GlobalColorSingleton.color;
    this.geometry = new RoundedBoxGeometry(size, size, 5, 6, 2);
    let defaultMaterial = new THREE.MeshPhongMaterial({
      color: DEFAULT_COLOR,
      shininess: 100,
      specular: 0x222222,
    });
    let cubeMaterialArray = [];
    // order to add materials: x+,x-,y+,y-,z+,z-
    cubeMaterialArray.push(defaultMaterial);
    cubeMaterialArray.push(defaultMaterial);
    cubeMaterialArray.push(defaultMaterial);
    cubeMaterialArray.push(defaultMaterial);

    cubeMaterialArray.push(
      new THREE.MeshBasicMaterial({
        color: 0xffffff,
      })
    );
    cubeMaterialArray.push(defaultMaterial);
    this.cube = new THREE.Mesh(this.geometry, cubeMaterialArray);
    // this.cube.castShadow = true;
    // this.cube.receiveShadow = true;
    this.cube.position.z = -size;
    // this.rotation.y = -Math.PI / 6;
    this.add(this.cube);
  }

  updateGeometry(size) {
    this.cube.geometry.dispose();
    this.geometry = new RoundedBoxGeometry(size, size, 5, 6, 2);
    this.cube.geometry = this.geometry;
  }

  roll() {
    if (!this.roll_is_authorized) return;
    this.roll_is_authorized = false;
    // console.log("roll");
    if (this.ROLL_TWEEN) this.ROLL_TWEEN.stop();
    if (this.TEXTURE_TIMEOUT) clearTimeout(this.TEXTURE_TIMEOUT);
    let index = 0;
    if (this.letter && this.letter.letter != " ") {
      index =
        this.letter.index >= this.textures[this.letter.letter].length - 1
          ? 0
          : this.letter.index + 1;
      this.TEXTURE_TIMEOUT = setTimeout(() => {
        this.updateTexture(this.letter.letter, index);
      }, 400);
    }
    const goal = Math.PI * 2;

    this.ROLL_TWEEN = new TWEEN.Tween(this.cube.rotation)
      .to({ x: goal }, 2000)
      .easing(TWEEN.Easing.Elastic.Out)
      .onComplete(() => {
        this.cube.rotation.x = 0;
        this.roll_is_authorized = true;
      })
      .start();
  }

  updateTexture(_letter, _index) {
    let letter = _letter.toLowerCase();
    let texture = null;
    if (this.textures[letter]) texture = this.textures[letter];
    else texture = this.textures["default"];
    const index = _index;
    // if (this.cube.material[4].map) this.cube.material[4].map.dispose();
    this.cube.material[4].map = texture[index];
    this.cube.material[4].needsUpdate = true;
    this.letter = { letter: letter, index: index };
  }

  hide() {
    new TWEEN.Tween(this.cube.scale)
      .to({ x: 0, y: 0, z: 0 }, 400)
      .easing(TWEEN.Easing.Back.In)
      .onComplete(() => {
        AudioEffects.playRandom(120);
      })
      .start();
  }
}
